const featuredCard = [
  {
    id: 1,
    title: 'Fill up the form',
    subTitle: 'Fill in your basic information to join the Gym Club.',
    icon: 'form',
  },
  {
    id: 2,
    icon: 'find',
    title: 'Find your perfect gym',
    subTitle: 'Easily find your perfect gym club and join the club instantly.',
  },
  {
    id: 3,
    icon: 'progress',
    title: 'Track your progress',
    subTitle: 'Analyze and plan for your tasks and progress.',
  },
];

const packageDetails = [
  {
    id: 1,
    title: 'Pilates',
    subTitle:
      'Developed first by Joseph Pilates, after whom the technique is name…',
    price: '$ 4,220/6 mo.',
  },
  {
    id: 2,
    title: 'Yoga & Meditation',
    subTitle:
      'Mantra has always believed in a Mind & Body approach which means…',
    price: '$ 4,220/6 mo.',
  },
  {
    id: 3,
    title: 'Kettlebell',
    subTitle:
      'Kettlebell, the exercise routine involving a kettle shaped weight originat…',
    price: '$ 4,220/6 mo.',
  },
];

const sampleData = { packageDetails, featuredCard };
export default sampleData;
